import { ScrollContainer } from '../../ScrollContainer'
import { Container } from '../Container'

import * as styles from './ScrollContainers.module.css'

function ScrollContainers() {
  return (
    <>
      <Container label='ScrollContainer, scrollbars: both'>
        <ScrollContainer className={styles.container}>
          <div
            className={styles.content}
            style={{ height: '175%', width: '175%' }}
          />
        </ScrollContainer>
      </Container>

      <Container label='ScrollContainer, scrollbars: vertical'>
        <ScrollContainer className={styles.container}>
          <div
            className={styles.content}
            style={{ height: '175%', width: '100%' }}
          />
        </ScrollContainer>
      </Container>

      <Container label='ScrollContainer, scrollbars: horizontal'>
        <ScrollContainer className={styles.container}>
          <div
            className={styles.content}
            style={{ height: '100%', width: '175%' }}
          />
        </ScrollContainer>
      </Container>

      <Container label='ScrollContainer, scrollbars: none'>
        <ScrollContainer className={styles.container}>
          <div
            className={styles.content}
            style={{ height: '100%', width: '100%' }}
          />
        </ScrollContainer>
      </Container>
    </>
  )
}

export default ScrollContainers
